import React, { useState, useEffect, FormEvent } from 'react';
import { Container, Button, Form, Message, Loader } from 'semantic-ui-react';
import dayjs from 'dayjs';
import Globals from '../Globals';
import 'dayjs/locale/fr'; // import locale
import { IGroupBookingQuote } from '../Models/IGroupBookingQuote';
import QuotesApi from '../api/QuotesApi';

dayjs.locale('fr');

const AnnulationDevisGroupes = () => {
  const searchParams = new URLSearchParams(document.location.search);
  const bookingId = searchParams.get('b');
  const quoteId = searchParams.get('q');
  const [quote, setQuote] = useState<IGroupBookingQuote>();
  const [canSubmit, setCanSubmit] = useState<boolean>(true);
  const [sending, setSending] = useState<boolean>(false);
  const [sent, setSent] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const qApi = new QuotesApi();

  useEffect(() => {
    if (bookingId && quoteId) {
      if (!quote) {
        const qApi = new QuotesApi();
        qApi.getGroupBooking(bookingId, quoteId)
          .then((res) => {
            if (res.data.status !== "BOOKED") {
              setErrorMessage(`Vous ne pouvez plus mettre à jour le devis n°${quoteId} (annulé)`);
              setCanSubmit(false);
            }
            if (res.data.quoteDueDate) {
              if (!res.data.quoteValidationDate && dayjs(res.data.quoteDueDate) < dayjs()) {
                setErrorMessage(`Vous ne pouvez plus mettre à jour le devis n°${quoteId} (devis non confirmé et date de validité dépassée)`);
                setCanSubmit(false);
              }
            }
            else {
              if (dayjs(res.data.eventDate).subtract(15, 'day') < dayjs()) {
                setErrorMessage(`Vous ne pouvez plus mettre à jour le devis n°${quoteId} en ligne (nous contacter)`);
                setCanSubmit(false);
              }
            }

            setQuote(res.data);
          }).catch(() => {
            // Error
            setErrorMessage(`Devis inconnu, veuillez-nous contacter par mail.`);
          })
      }
    } else {
      setErrorMessage(`Devis inconnu, veuillez-nous contacter par mail.`);
    }
  }, [quote, bookingId, quoteId]);

  const handleImportSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (bookingId && quoteId) {
      setErrorMessage(undefined);
      setSending(true);
      qApi.cancelGroupBookingQuote(bookingId, quoteId)
        .then(() => {
          setSent(true);
        }).catch(() => {
          setErrorMessage(`Une erreur est survenue lors de l'envoi du fichier. Retentez plus tard ou envoyez-le nous sur ${Globals.Email}.`);
        }).finally(() => {
          setSending(false);
        });
    }
    return
  }

  return (<Container fluid>
    <h3>Annulation de votre devis</h3>
    {bookingId && quoteId && !quote && (<Loader active inline>Chargement du devis...</Loader>)}
    {bookingId && quoteId && quote && (<Form onSubmit={handleImportSubmit}>
      <h4>Devis concerné: <i>{quote.quoteId}</i>.</h4>
      <div style={{ paddingBottom: 15 }}>Vous souhaitez annuler votre demande de devis ? Il vous suffit de confirmer ci-dessous afin de libérer le créneau horaire demandé dans votre devis.</div>
      <div style={{ paddingBottom: 15 }}><Button primary type="submit" loading={sending} disabled={sending || sent || !canSubmit}>Annuler le devis</Button></div>
      {sent && (<Message positive>Votre demande d'annulation a bien été prise en compte, merci !</Message>)}
    </Form>)}
    {errorMessage && (<Message negative>{errorMessage}</Message>)}
  </Container>);
}

export default AnnulationDevisGroupes;
